export default "__VITE_ASSET__BC$fT5Ja__"